


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class KnowledgeCheckHeader extends Vue {
  @Prop() question!: string;
  @Prop() image!: string;
  @Prop({default:''}) imageAlt!: string;
  @Prop() instructions!: string;
  @Prop() accessibilityInstructions!: string;
  @Prop({default:'#fff'}) backgroundColor !: string;
}
